/**
 * DEV-1018. i18n аналитики презентаций (Reports-таб + таб карточки агента).
 * Overlay-модуль: подмешивается deepMerge поверх базовых локалей (reports.*,
 * agentsRegistry.*), чтобы не раздувать монолитные ru/en/vn.
 */
export const presentationsAnalyticsMessages = {
  ru: {
    reports: {
      tabs: { presentations: 'Презентации' },
      presentations: {
        subtitle: 'Создание и просмотры презентаций агентов',
        sinceNote: 'Статистика собирается с июля 2026',
        kpiCreated: 'Создано',
        kpiSent: 'Отправлено',
        kpiViews: 'Просмотры',
        kpiConversion: 'Конверсия',
        chartTitle: 'Динамика по дням',
        tableTitle: 'Активность агентов',
        seriesCreated: 'Создано',
        seriesSent: 'Отправлено',
        seriesViews: 'Просмотры',
        colAgent: 'Агент',
        colCreated: 'Создано',
        colSent: 'Отправлено',
        colViews: 'Просмотры',
        colConversion: 'Конверсия',
        empty: 'Пока нет данных',
        emptyDescription:
          'Статистика появится, когда агенты начнут создавать и отправлять презентации.',
      },
    },
    agentsRegistry: {
      tabs2: { presentations: 'Презентации' },
      presentations: {
        topTitle: 'Топ презентаций',
        colTitle: 'Название',
        untitled: 'Без названия',
        deleted: '· удалена',
      },
    },
  },
  en: {
    reports: {
      tabs: { presentations: 'Presentations' },
      presentations: {
        subtitle: 'Agent presentation creation and views',
        sinceNote: 'Statistics collected since July 2026',
        kpiCreated: 'Created',
        kpiSent: 'Sent',
        kpiViews: 'Views',
        kpiConversion: 'Conversion',
        chartTitle: 'Daily dynamics',
        tableTitle: 'Agent activity',
        seriesCreated: 'Created',
        seriesSent: 'Sent',
        seriesViews: 'Views',
        colAgent: 'Agent',
        colCreated: 'Created',
        colSent: 'Sent',
        colViews: 'Views',
        colConversion: 'Conversion',
        empty: 'No data yet',
        emptyDescription:
          'Statistics will appear once agents start creating and sending presentations.',
      },
    },
    agentsRegistry: {
      tabs2: { presentations: 'Presentations' },
      presentations: {
        topTitle: 'Top presentations',
        colTitle: 'Title',
        untitled: 'Untitled',
        deleted: '· deleted',
      },
    },
  },
  vn: {
    reports: {
      tabs: { presentations: 'Bài giới thiệu' },
      presentations: {
        subtitle: 'Tạo và lượt xem bài giới thiệu của đại lý',
        sinceNote: 'Thống kê thu thập từ tháng 7 2026',
        kpiCreated: 'Đã tạo',
        kpiSent: 'Đã gửi',
        kpiViews: 'Lượt xem',
        kpiConversion: 'Chuyển đổi',
        chartTitle: 'Diễn biến theo ngày',
        tableTitle: 'Hoạt động của đại lý',
        seriesCreated: 'Đã tạo',
        seriesSent: 'Đã gửi',
        seriesViews: 'Lượt xem',
        colAgent: 'Đại lý',
        colCreated: 'Đã tạo',
        colSent: 'Đã gửi',
        colViews: 'Lượt xem',
        colConversion: 'Chuyển đổi',
        empty: 'Chưa có dữ liệu',
        emptyDescription: 'Thống kê sẽ xuất hiện khi đại lý bắt đầu tạo và gửi bài giới thiệu.',
      },
    },
    agentsRegistry: {
      tabs2: { presentations: 'Bài giới thiệu' },
      presentations: {
        topTitle: 'Bài giới thiệu hàng đầu',
        colTitle: 'Tiêu đề',
        untitled: 'Không có tiêu đề',
        deleted: '· đã xóa',
      },
    },
  },
}
